import Choices from 'choices.js';
import '../../../../node_modules/choices.js/public/assets/styles/choices.css';
import Swiper, { EffectFade, Autoplay } from 'swiper';
import '../../../../node_modules/swiper/modules/effect-fade/effect-fade.scss';
import { playPauseVideo, resetVideoControls } from '../helpers/video.js';

Swiper.use([EffectFade, Autoplay]);

import {setCookie, getCookie} from './utilities.js';

// Add this variable at the top level to track the element that triggered the popup
let lastFocusedElement = null;

export const closePopupsButtonWatcher = () => {

	//Close popup
	const closePopupLinksOnPage = document.querySelectorAll('.js__close-popups'); //Get all popup links on page
	
	if(closePopupLinksOnPage.length > 0){ //Check if there are any links first
		closePopupLinksOnPage.forEach((closePopupLink) => { //Loop through each and give it a onclick event listener
			closePopupLink.addEventListener('click', (event) => {
				event.preventDefault(); //Stop the link firing normally !
				// Pause all video elements
				const videoElements = document.querySelectorAll('.popup video');
				if (videoElements.length > 0) {
					videoElements.forEach((videoElement) => {
						videoElement.pause();
						videoElement.muted = true;
					});
				}

				closeAllPopups();

				// Return focus to the element that triggered the popup
				if (lastFocusedElement) {
					lastFocusedElement.focus();
					lastFocusedElement = null;
				}

				document.querySelector('body').classList.remove('js__popup-active');
				document.querySelector('#js__body').classList.remove('js__popup-active');
				document.querySelector('#js__body').dataset.popup = '';
			});
		});
	}

	//Close popup on esc key press
	document.addEventListener('keyup', (event) => {
		if (event.key === 'Escape') {
			if ( document.querySelector('.popup.active') ) {				
				// Pause all video elements
				const videoElements = document.querySelectorAll('.popup video');
				if (videoElements.length > 0) {
					videoElements.forEach((videoElement) => {
						videoElement.pause();
						videoElement.muted = true;
					});
				}
	
				closeAllPopups();
				
				// Return focus to the element that triggered the popup
				if (lastFocusedElement) {
					lastFocusedElement.focus();
					lastFocusedElement = null;
				}

				document.querySelector('body').classList.remove('js__popup-active');
				document.querySelector('#js__body').classList.remove('js__popup-active');
				document.querySelector('#js__body').dataset.popup = '';

			}
		}
	});
}

export const openPopup = (targetPopupID) => {
	// Store the currently focused element before opening popup
	lastFocusedElement = document.activeElement;
	
	var targetPopup = document.querySelector(targetPopupID); //Select the popup
	if(targetPopup){ //Check we have a valid target popup
		if(targetPopupID == '#main-nav' && document.querySelector('#js__body').classList.contains('js__popup-active')){ //If target popup is the main nav, and there's already a popup active, this is a click on the hamburger so treat it as the close button
			closeAllPopups();
			document.querySelector('body').classList.remove('js__popup-active');
			document.querySelector('#js__body').classList.remove('js__popup-active');
			document.querySelector('#js__body').dataset.popup = '';
		}else{ //Otherwise open the popup as normal
			closeAllPopups();//Make sure no popups are currently open
			targetPopup.classList.add('active'); //Activate the popup!
			document.querySelector('body').classList.add('js__popup-active'); //Add class to body to show popup is open
			document.querySelector('#js__body').classList.add('js__popup-active'); 
			document.querySelector('#js__body').dataset.popup = targetPopupID;

			//Handle small popups - hide the main nav close button
			if ( targetPopup.classList.contains('appearance__small') ) {
				document.querySelector('#js__body').classList.add('js__small-popup-active');
			}

			//Make sure the correct main nav link image is showing on popup
			/* if ( targetPopupID === '#main-nav' ) {
				const mainNavLinks = document.querySelectorAll('.js__nav-link'); //Get all nav links
				
				if ( mainNavLinks.length > 0 ) {
					mainNavLinks.forEach((navLink) => {
						if ( navLink.classList.contains('current') ) {
							const currentNavHoverIndex = navLink.dataset.item;
			
							if(currentNavHoverIndex){
								const navImages = document.querySelectorAll('.main-nav__image');
			
								if ( navImages ) {
									navImages.forEach((navImage) => {
										if (navImage.dataset.item == currentNavHoverIndex) {
											navImage.classList.add('active');
										} else {
											navImage.classList.remove('active');
										}
									})
								}
							}
						}
					});
				}			
			} */

			// Set focus to the first focusable element in the popup
			const focusableElements = targetPopup.querySelectorAll(
				'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
			);
			console.log('eeee', focusableElements);
			if (focusableElements.length > 0) {
				focusableElements[0].focus();
			}

			// Add focus trap to keep focus within popup
			targetPopup.addEventListener('keydown', trapFocus);
		}
	}else{
		console.warn('Missing Popup: '+targetPopupID);
	}
}

// Add this new function to trap focus within the popup
const trapFocus = (e) => {
	if (e.key === 'Tab') {
		const popup = e.currentTarget;
		const focusableElements = popup.querySelectorAll(
			'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
		);
		const firstFocusableElement = focusableElements[0];
		const lastFocusableElement = focusableElements[focusableElements.length - 1];

		if (e.shiftKey) {
			if (document.activeElement === firstFocusableElement) {
				lastFocusableElement.focus();
				e.preventDefault();
			}
		} else {
			if (document.activeElement === lastFocusableElement) {
				firstFocusableElement.focus();
				e.preventDefault();
			}
		}
	}
};

export const closeAllPopups = () => {
	var openPopups = document.querySelectorAll('.popup.active');
	if(openPopups.length > 0){
		openPopups.forEach((openPopup) => {
			openPopup.classList.remove('active');
		});
	}
	let regionsPopupsOld = document.querySelectorAll('.m__llist__regions');
	if(regionsPopupsOld){
		regionsPopupsOld.forEach((regionsPopup) => {
			regionsPopup.classList.remove('active');
		})
	}

	const regionsPopups = document.querySelectorAll('.e__regions-popup');

	if ( regionsPopups ) {
		regionsPopups.forEach(regionsPopup => {
			document.querySelector('body').classList.remove('js__regions-popup-active');
			regionsPopup.classList.remove('active');
		});
	}


	document.querySelector('body').classList.remove('js__small-popup-active');
	document.querySelector('#js__body').classList.remove('js__small-popup-active');

	// Remove focus trap from all popups
	const popups = document.querySelectorAll('.popup');
	popups.forEach(popup => {
		popup.removeEventListener('keydown', trapFocus);
	});

	// Return focus to trigger element
	if (lastFocusedElement) {
		lastFocusedElement.focus();
		lastFocusedElement = null;
	}
}


export const triggerCustomPopups = () => {
	//Function to launch any custom popups
	let customPopups = document.querySelectorAll('.popup.custom-popup');

	if(customPopups.length > 0){ //Check if there are any links first
		customPopups.forEach((customPopup) => {
			let displayType 	= customPopup.dataset.type,
				displayPages 	= customPopup.dataset.pages,
				displayPeriod 	= customPopup.dataset.period,
				currentPageID   = document.querySelector('#js__body').dataset.page,
				triggerPopup   	= false;


			if(displayType != 'trigger'){ //Ignore if manually triggered
				//First check if the visitor already has the cookie, or if the popup is set to always display
				if(displayPeriod == 0){
					triggerPopup = true;
				}else{
					let hasCookie = getCookie(customPopup.getAttribute('id'));
					if(hasCookie){
						//User has cookie, don't show the popup
					}else{
						triggerPopup = true;
					}
				}


				//If we're in the trigger period, check to see if we're on the right page
				if(triggerPopup){ //No point continuing if they failed the period check!
					if(displayType == 'all'){
						triggerPopup = true;
					}else if(displayType == 'exclude' && !(displayPages.includes(currentPageID)) && currentPageID != ""){
						triggerPopup = true;
					}else if(displayType == 'include' && displayPages.includes(currentPageID) && currentPageID != ""){
						triggerPopup = true;
					}else{
						triggerPopup = false;
					}
				}

				if(triggerPopup){ //Show the popup and add a cookie if needed
					openPopup('#'+customPopup.getAttribute('id'));
					if(displayPeriod > 0){
						setCookie(customPopup.getAttribute('id'),true,displayPeriod);
					}
				}
			}
		});
	}	
}

export const initPopupMediaSlider = (slider = null) => {
	if ( slider ) {
		const sliderSlides = slider.querySelectorAll('.js-popup-media-slider-slide');

		// Check if the first slide contains a video and if so play the video
		const initSlide = sliderSlides[0];
		const initSlideVideo = initSlide.querySelector('.js__popup-media-swiper-video'); 

		if ( initSlideVideo ) {
			initSlideVideo.play();
		}

		// Loop through each slide and initialise the playPuase functionality
		sliderSlides.forEach(slide => {
			const video = slide.querySelector('.js__popup-media-swiper-video');
			const videoControls = slide.querySelector('.js-video-controls');
	
			if ( video && videoControls ) {
				playPauseVideo(video, videoControls);
			}
		});

		if (sliderSlides.length > 1) {
			// Initialise the slider
			const popupMediaSlider = new Swiper(slider, {
				centeredSlides: true,
				slidesPerView: 1,
				effect: "fade",
				speed: 1500,
				fadeEffect: {
					crossFade: true
				},
				shortSwipes: false,
				autoplay: {
					delay: 3000,
					disableOnInteraction: true,
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
			});

			let sliderNextArrow = slider.closest('.popup').querySelector('.js__team-popup__swiper-next');
			let sliderPrevArrow = slider.closest('.popup').querySelector('.js__team-popup__swiper-prev');

			// Show the arrows
			if (sliderNextArrow) {
				sliderNextArrow.classList.remove('hidden');
			}
			if (sliderPrevArrow) {
				sliderPrevArrow.classList.remove('hidden');
			}

			popupMediaSlider.on('slideChange', function () {
				// If the previous slide contains a video then pause the video
				const prevSlideVideo = popupMediaSlider.slides[popupMediaSlider.previousIndex].querySelector('.js__popup-media-swiper-video');

				if ( prevSlideVideo ) {
					prevSlideVideo.pause();
				}

				// Check if the current slide contains a video
				const currentSlide = popupMediaSlider.slides[popupMediaSlider.activeIndex];
				const currentSlideVideo = currentSlide.querySelector('.js__popup-media-swiper-video');
				const currentSlideVideoControls = currentSlide.querySelector('.js-video-controls');

				if ( currentSlideVideo && currentSlideVideoControls ) {
					// If the play icon is hidden this means that the video hasn't been paused before changing slides so play the video
					const playIcon = currentSlideVideoControls.querySelector('.e__video-controls-image--play');

					if ( playIcon && playIcon.classList.contains('hidden') ) {
						currentSlideVideo.play();
					}
				}
			});
			
			// Move to the previous slide if 'prev' arrow clicked
			if (sliderPrevArrow) {
				sliderPrevArrow.addEventListener('click', (event) => {
					let prevSlide = popupMediaSlider.activeIndex - 1;
					if (prevSlide < 0) {
						prevSlide = popupMediaSlider.slides.length; // Set to the last slide
					}
					popupMediaSlider.slideTo(prevSlide);
				})
			}

			// Move to the next slide if 'next' arrow clicked
			if (sliderNextArrow) {
				sliderNextArrow.addEventListener('click', (event) => {
					let nextSlide = popupMediaSlider.activeIndex + 1;
					if (nextSlide >= popupMediaSlider.slides.length) {
						nextSlide = 0; // Return to start!
					}
					popupMediaSlider.slideTo(nextSlide);
				})
			}  			
		}
	}
}